<template>
  <div id="katalog-tiket">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{ path: '/' }">Home</router-link></li>
      <li>Content</li>
      <li class="active">Content Video Gratis</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Video Gratis</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right">
              <button
                type="button"
                class="btn btn-success btn-xs m-r-5"
                @click="createContentVideo()"
              >
                <span class="fa fa-plus"></span> Tambah Video
              </button>
              <!-- <button type="button" class="btn btn-success btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								Action <span class="caret"></span>
							</button>
							<ul class="dropdown-menu">
								<li><a @click="updateAllKatalogTiketStatus(status.PUBLISH)">Publish All</a></li>
								<li><a @click="updateAllKatalogTiketStatus(status.UNPUBLISH)">Unpublish All</a></li>
							</ul> -->
            </div>
            <h4 class="panel-title">List Content Video</h4>
          </div>
          <div class="panel-body">
            <app-datatable
              :items="VideoList"
              :has-action="true"
              :has-custom-pagination="true"
              :has-custom-search="true"
              :has-publish="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="10"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              :headers="headers"
              v-on:selected="selectedRow = $event"
              v-on:dblClicked="updateVideo()"
              v-on:deleted="deleteVideo($event)"
              v-on:changePage="
                pagination = { ...pagination, currentPage: $event }
              "
              v-on:changeSortMode="
                pagination = { ...pagination, sortMode: $event }
              "
              v-on:doSearch="
                search = { query: $event.value, by: headersKey[$event.key] }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import ContentService from "@/services/content.js";
import DataTable from "@/components/plugins/DataTable";
import Spinner from "@/components/plugins/Spinner";
import Moment from "moment";

export default {
  name: "katalog-tiket",
  components: {
    "app-datatable": DataTable,
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      isLoading: false,
      VideoList: [],
      fullData: [],
      status: {
        PUBLISH: "PUBLISHED",
        UNPUBLISH: "UNPUBLISHED",
      },
      selectedRow: null,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: "desc",
      },
      type: {
        // SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
        // INSTANT_TRYOUT: 'INSTANT_TRYOUT',
        // CONSULTATION: 'CONSULTATION',
        // DUEL: 'DUEL',
        // ITEM_BANK: 'ITEM_BANK',
        // VIDEO: 'VIDEO'
      },
      headers: ["Judul Video", "Kelas", "Duration"],
      headersKey: ["title", "grade", "duration"],
    };
  },
  mounted: function () {
    this.fetchData();
  },
  watch: {
    pagination: function () {
      this.fetchData();
    },
  },
  methods: {
    fetchData: function () {
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode,
      };

      this.isLoading = true;

      ContentService.getContentVideoList(pagination, search, function (result) {
        context.VideoList = [];
        context.isLoading = false;

        if (result.success) {
          if (pagination.currentPage > 1 && result.data.length < 1) {
            context.pagination.currentPage =
              parseInt(pagination.currentPage) - 1;
            alert(
              "Data hanya sampai halaman " + context.pagination.currentPage
            );
            context.fetchData();
          } else if (pagination.currentPage === 1 && result.data.length === 0) {
            alert("Maaf, data belum ada ");
          }
          result.data.forEach(function (content) {
            var grades = [];
            content.grades.forEach(function (detailed) {
              grades += " " + detailed.grade;
            });
            var row = {
              id: content.id,
              data: [content.title, grades, content.duration],
            };
            context.pagination.totalPages = content.total_page;
			context.VideoList.push(row)
            context.fullData.push(content);
          });
        } else {
          alert("Terjadi Kesalahan : " + result.data.message);
        }
      });
    },
    createContentVideo: function () {
      this.$router.push({ path: "/content/video-form" });
    },
    updateVideo: function () {
      var selected = this.fullData.find((element) => {
        return element.id == this.selectedRow.id;
      });
      this.$store.commit("setEditDataContent", selected);
      this.$router.push({
        path: "/content/video-form",
        query: { id: this.selectedRow.id },
      });
    },
    deleteVideo: function (content) {
      var context = this;
      var contentID = content.id;
      var confirmed = window.confirm(
        "Apakah anda yakin akan menghapus Konten Video Gratis ini?"
      );
      if (confirmed) {
        this.isLoading = true;
        ContentService.deleteContentVideo(contentID, function (result) {
          context.isLoading = false;
          if (result.success) {
            alert("Data Terhapus");
            context.fetchData();
          } else {
            alert("Terjadi Kesalahan : " + result.message);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// FreeVideo.vue?79248e29